function ensureYoutubeAPIReady() {
	return new Promise((resolve, reject) => {
		if (window.YT && window.YT.Player) {
			return resolve();
		}

		let otherYoutubeReadyCb = null;
		if (typeof window.onYouTubeIframeAPIReady !== "undefined") {
			otherYoutubeReadyCb = window.onYouTubeIframeAPIReady;
		}

		window.onYouTubeIframeAPIReady = () => {
			otherYoutubeReadyCb && otherYoutubeReadyCb();
			resolve();
		};

		let script = document.createElement("script");
		script.id = "youtube-iframe-script";
		script.src = "https://www.youtube.com/iframe_api";
		let firstScriptTag = document.getElementsByTagName("script")[0];
		firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
	});
}

function ensureVimeoAPIReady() {
	return new Promise((resolve, reject) => {
		if (window.Vimeo && window.Vimeo.Player) {
			return resolve();
		}

		let script = document.createElement("script");
		script.id = "vimeo-iframe-script";
		script.src = "https://player.vimeo.com/api/player.js";

		// Set up onload event handler
		script.onload = () => {
			// Check if the necessary objects are now available
			if (window.Vimeo && window.Vimeo.Player) {
				resolve();
			} else {
				reject(
					new Error(
						"Vimeo API script loaded, but Vimeo or Vimeo.Player is still not available",
					),
				);
			}
		};

		// Set up onerror event handler
		script.onerror = () => {
			reject(new Error("Error loading Vimeo API script"));
		};

		let firstScriptTag = document.getElementsByTagName("script")[0];
		firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
	});
}

const removePosterImage = (video) => {
	const poster = video.querySelector(".two-cols-left-right__background-image");

	if (poster) {
		poster.style.opacity = 0;
	}
};

const handleIframeVideos = () => {
	const videoCollection = document.getElementsByClassName(
		"two-cols-left-right__background-video-wrapper",
	);

	if (videoCollection) {
		const videoArray = Array.from(videoCollection);

		videoArray.forEach((videoItem) => {
			// handle local videos
			if (videoItem.dataset.videoType === "video-local") {
				const frame = videoItem.getElementsByTagName("video");
				frame[0].addEventListener("play", () => {
					removePosterImage(videoItem);
				});
			}

			// handle youtube videos
			if (videoItem.dataset.videoType === "video-youtube") {
				ensureYoutubeAPIReady().then(() => {
					videoArray.forEach((video, i) => {
						// events if youtube video is loaded
						const frame = video.getElementsByTagName("iframe");
						if (frame.length) {
							const player = new YT.Player(frame[0], {
								events: {
									onReady: () => {
										isPlayerReady = true;
									},
									onStateChange: (e) => {
										if (e.target.getPlayerState() === 1) {
											removePosterImage(video);
										}

										if (e.target.getPlayerState() === 0) {
											e.target.playVideo();
										}
									},
								},
							});
						}
					});
				});
			}

			// handle vimeo videos
			if (videoItem.dataset.videoType === "video-vimeo") {
				ensureVimeoAPIReady().then(() => {
					videoArray.forEach((video, i) => {
						// events if Vimeo video is loaded
						const frame = video.getElementsByTagName("iframe");

						if (frame.length) {
							if (video.dataset.videoType === "video-vimeo") {
								const player = new Vimeo.Player(frame[0]);

								player.on("play", () => {
									removePosterImage(video);
								});
							}
						}
					});
				});
			}
		});
	}
};

if (document.readyState !== "loading") {
	handleIframeVideos();
} else {
	document.addEventListener("DOMContentLoaded", handleIframeVideos);
}
